/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react"
import LocationModal from "../common/LocationModal"


const Banner = ({ bannerInfo, businessName, locationInfo, websiteBackgroundColor, websiteTextColor }) => {

  const [isModalVisible, setIsModalVisible] = useState(false);
  const pathName = window.location.origin

  let showPopUp = false
  if (locationInfo?.length > 1) {
    showPopUp = true
  }

  const sectionStyle = {
    backgroundImage: `url(${bannerInfo?.banner_image_url || `${pathName}/assets/default/banner-default.jpg`})`,
    borderRadius: '8px',
  };

  const bannerHeadingStyle = {
    color: `${bannerInfo?.banner_heading_text_color || '#ffffff'}`,
    fontFamily: bannerInfo?.banner_heading_text_font,
    fontSize: `${bannerInfo?.banner_heading_text_size}px`,
    lineHeight: `${bannerInfo?.banner_heading_text_size}px`,
  };

  /* const bannerHeadingColor2 = {
    color: `${bannerInfo?.banner_heading_text_color || '#ffffff'}`,
    fontFamily: 'Times New Roman'
  }; */

  const bannerSubHeadingStyle = {
    color: `${bannerInfo?.banner_sub_heading_text_color || '#ffffff'}`,
    fontFamily: bannerInfo?.banner_sub_heading_text_font,
    fontSize: `${bannerInfo?.banner_sub_heading_text_size}px`,
  };

  const actionButtonText = `${bannerInfo?.call_to_action_button_text || 'Order Online'}`

  const OpenPopup = () => {
    setIsModalVisible(true);
  }

  const onCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <div className="banner banner-1 banner-4 light-banner" style={{ backgroundColor: websiteBackgroundColor }}>
        <div className="banner-item">
          <div
            className="banner-inner bg-cover bg-center dark-overlay dark-overlay-2"
            style={sectionStyle}
          >
            <div className="container">
              {bannerInfo?.banner_heading_text &&
                <h1 className="title" style={bannerHeadingStyle}>
                  {bannerInfo?.banner_heading_text}
                </h1>
              }
              {bannerInfo?.banner_sub_heading_text &&
                <p className="subtitle" style={bannerSubHeadingStyle}>
                  {bannerInfo?.banner_sub_heading_text}
                </p>
              }
              {showPopUp === false && (
                <a
                  href={bannerInfo?.call_to_action_url}
                  hidden={!bannerInfo?.call_to_action_url}
                  className="btn-header btn-banner-first"
                  rel="noreferrer"
                  target="_blank"
                  style={{width: '220px', display: 'table', marginLeft: 'auto', marginRight: 'auto'}}
                >
                  {bannerInfo?.call_to_action_button_text}
                </a>
              )}
              {showPopUp === true && (
                /*eslint no-script-url: "off"*/
                <a
                  href="javascript:void(0)"
                  className="btn-header btn-banner-first"
                  onClick={OpenPopup}
                  style={{width: '220px', display: 'table', marginLeft: 'auto', marginRight: 'auto'}}
                  // style={buttonBackgroundColor}
                >
                  {bannerInfo?.call_to_action_button_text}
                </a>
              )}
              {bannerInfo?.call_to_action_url_secondary && bannerInfo?.call_to_action_button_text_secondary && (
                <div style={{paddingTop: 30}}>
                  <a
                    href={bannerInfo?.call_to_action_url_secondary}
                    hidden={!bannerInfo?.call_to_action_url_secondary}
                    className="btn-header btn-banner-second"
                    rel="noreferrer"
                    target="_blank"
                    style={{width: '220px', display: 'table', marginLeft: 'auto', marginRight: 'auto'}}
                    // style={buttonBackgroundColorSecondary}
                  >
                    {bannerInfo?.call_to_action_button_text_secondary}
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <LocationModal
        visible={isModalVisible}
        onCancel={onCancel}
        locationInfo={locationInfo}
        businessName={businessName}
        actionButtonText={actionButtonText}
        websiteBackgroundColor={websiteBackgroundColor}
        websiteTextColor={websiteTextColor}
      />
    </>
  );
};

export default Banner;
